
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, Filter } from "lucide-react";
import { useTranslation } from "react-i18next";


interface JobOffersSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const JobOffersSearch = ({ searchTerm, setSearchTerm }: JobOffersSearchProps) => {

  const { t } = useTranslation(); 

  return (
    <div className="mb-6 flex flex-col sm:flex-row gap-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input 
          type="text"
          placeholder="Search job offers..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10"
        />
      </div>
      
      <div className="flex gap-2 items-center">
        <Button variant="outline" className="flex items-center gap-2 ml-2">
          <Filter className="h-4 w-4" />
          <span>{t("matchTest.skills")}</span>
        </Button>
        
        <Button variant="outline" className="flex items-center gap-2">
          <Filter className="h-4 w-4" />
          <span>Matches</span>
        </Button>
      </div>
    </div>
  );
};
